<!--
  ~ Copyright (c) 2026 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<bs-dialog [header]="translationSchema.task.list.closeMessage | translate"
          [visible]="visible()" (visibleChange)="visible.set($event)" [modal]="true"
          [style]="{ 'max-width': '30rem' }">
  <p style="white-space: normal; word-wrap: break-word;">{{ translationSchema.task.list.closeBody | translate }}</p>
  <ng-template #footer>
    <button bsButton [text]="true"
           
            (click)="visible.set(false)"><span bsButtonLabel>{{ translationSchema.utils.close | translate }}</span></button>
    <button bsButton
           
            (click)="closeTask()"><span bsButtonLabel>{{ translationSchema.task.list.closeTask | translate }}</span></button>
  </ng-template>
</bs-dialog>
